// This file is automatically generated with create-ts-svgs script in package.json
import * as React from 'react'; 
			
interface ISvgProps {
	className?: string,
}
			
const fn: React.FunctionComponent<ISvgProps> = (props) => (
	<svg className={props.className} xmlns="http://www.w3.org/2000/svg" viewBox="-4590 -2755 17.89 22.1"><path className="a" d="M-4578.955-2752.8l.6-.6a1 1 0 00-1.4-1.4l-2 2-.2.3a1 1 0 000 .8l.2.3 2 2a1 1 0 001.6-1.1 7 7 0 01.6 12.4 1 1 0 00.5 1.9h.5a9 9 0 00-2.4-16.5zM-4580.155-2736.5l-.2-.3-2-2a1 1 0 00-1.6 1.1 7 7 0 01-.6-12.4 1 1 0 00-1-1.7 9 9 0 002.4 16.5l-.6.6a1 1 0 101.4 1.4l2-2 .2-.3a1 1 0 000-.9z"/></svg>
);

export default fn;
